// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"389":"ea5f0897","453":"108f8756","732":"e72cd9bd","977":"faeef6fc"}[chunkId] + ".chunk.js";
};